import React, { PropsWithChildren, useContext } from 'react';

import { app, media } from 'context';
import { APP_BANNER_HEIGHT, Layout } from 'ds';
import { selectUIState } from 'store/UI/selectors';
import { useAppSelector } from 'store/hooks';

interface Props {
  showMobileBottomNav?: boolean;
}

const NavigationContainer: React.FC<PropsWithChildren<Props>> = ({ children, showMobileBottomNav }) => {
  const { xs, sm } = useContext(media);

  const { overflowY, bottomNavigationHeight } = useContext(app);
  const { appBannerType } = useAppSelector(selectUIState);
  const hasBanner = !!appBannerType;

  return (
    <Layout
      flexGrow={1}
      marginTop={hasBanner ? APP_BANNER_HEIGHT : 0}
      {...(xs || sm
        ? overflowY === 'hidden'
          ? { minHeight: '100vh' }
          : { paddingBottom: showMobileBottomNav === false ? 0 : bottomNavigationHeight, minHeight: '100vh' }
        : { minHeight: '100%' })}
      flex
    >
      {children}
    </Layout>
  );
};

export default NavigationContainer;
